import { useAccount, useReadContracts } from 'wagmi';
import erc20_json from 'mode-shared/constants/abis/ERC20.json';
import { Address } from 'viem';
import localConfig from 'mode-shared/configs/config';

const MODE_CHAIN_ID = Number(localConfig.l2ChainId);

export interface UseModeTokenBalanceProps {
  token: Address;
}

export interface UseModeTokenBalanceReturn {
  data: {
    value: string;
    decimals: number;
    symbol: string;
  } | null;
  isLoading: boolean;
  isRefetching: boolean;
  getBalance: () => void;
}

export const useModeTokenBalance = ({ token }: UseModeTokenBalanceProps): UseModeTokenBalanceReturn => {
  const { address } = useAccount();

  const { data, isLoading, isRefetching, refetch } = useReadContracts<[string, number, string]>({
    allowFailure: false,
    query: {
      staleTime: 0,
      enabled: !!address,
    },
    contracts: [
      {
        address: token,
        abi: erc20_json.abi,
        functionName: 'balanceOf',
        args: [address?.toLowerCase()],
        chainId: MODE_CHAIN_ID,
      },
      {
        address: token,
        abi: erc20_json.abi,
        functionName: 'decimals',
        chainId: MODE_CHAIN_ID,
      },
      {
        address: token,
        abi: erc20_json.abi,
        functionName: 'symbol',
        chainId: MODE_CHAIN_ID,
      },
    ],
  });

  return {
    data: data
      ? {
          value: data[0] as unknown as string,
          decimals: data[1] as unknown as number,
          symbol: data[2] as unknown as string,
        }
      : null,
    isLoading: isLoading,
    isRefetching,
    getBalance: refetch,
  };
};
